/**
 * Lazy Loading
 *
 * If IntersectionObserver is available, lazy-loads wistia API script when a Wistia iframes is scrolled into view.
 */
import { loadAsync } from './loadAsync';

export function initLazyLoading() {
  if ('IntersectionObserver' in window) {
    installObserver();
  } else {
    loadWistiaScript();
  }
}

function installObserver() {
  const iframes = document.querySelectorAll('iframe.wistia_embed');
  const cb = function (entries: IntersectionObserverEntry[]) {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        const iframe: HTMLIFrameElement = entry.target as HTMLIFrameElement;

        if (iframe.src === '' && iframe.dataset.src != undefined) {
          iframe.src = iframe.dataset.src;
        }

        observer.unobserve(iframe);
        loadWistiaScript();
      }
    });
  };
  const observer = new IntersectionObserver(cb, {
    root: null,
    rootMargin: '150px',
    threshold: 0.1,
  });

  iframes.forEach(elem => observer.observe(elem));
}

function loadWistiaScript(): Promise<HTMLScriptElement> {
  const scriptSrc = 'https://fast.wistia.net/assets/external/E-v1.js';

  const elem = document.querySelector<HTMLScriptElement>(`script[src="${scriptSrc}"]`);

  if (elem == null) {
    return loadAsync(scriptSrc);
  }

  return Promise.resolve(elem);
}
